import Helmet from "react-helmet"

import PageContainer from "@podcastsoundboard/ps-lib/components/PageContainer/PageContainer"

import AppBar from "../../components/AppBar"
import Footer from "../../components/Footer"
import FullPageContentContainer from "../../components/FullPageContentContainer"
import { useAppSelector } from "../../redux"
import { Paper, Toolbar, Typography } from "@podcastsoundboard/ps-lib/ui"

export default function Privacy() {
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)
  return (
    <PageContainer darkModeEnabled={darkModeEnabled} className="min-h-screen">
      <AppBar title="Podcast Soundboard" />

      <Helmet title="Podcast Soundboard Privacy Statement" />

      <Toolbar />

      <FullPageContentContainer>
        <Paper className="p-8 my-8 flex flex-col">
          <Typography
            component="h1"
            variant="h2"
            align="left"
            color="text.primary"
            gutterBottom
          >
            Privacy Statement
          </Typography>

          <Typography variant="body1" color="text.primary">
            Data you provide is stored in a database hosted in the United
            States. We rely on a number of third party service providers to
            operate the application, and some of these providers process your
            data on our behalf. They may collect usage data or otherwise track
            you via their software integrations, as listed below.
            <br />
            <br />
            <b>Third party service providers</b>
            <ul>
              <li>
                <b>Amazon Web Services (AWS)</b> &mdash; hosts our file storage
                and backups and delivers uploaded files through its content
                delivery network. Audio files and images that you upload are
                stored with AWS.
              </li>
              <li>
                <b>Stripe</b> &mdash; provides payment services and will store
                your payment information and transaction data.
              </li>
              <li>
                <b>Google</b> &mdash; provides reCAPTCHA (bot protection) and
                Google Analytics (usage analytics) and will collect usage data.
              </li>
              <li>
                <b>Meta (Facebook)</b> &mdash; provides analytics via its
                tracking pixel and will collect usage data.
              </li>
              <li>
                <b>EmailOctopus</b> &mdash; sends newsletter and marketing
                emails and stores the email address and name of subscribers.
              </li>
              <li>
                <b>Email delivery provider</b> &mdash; transactional and account
                related emails are sent on our behalf by a third party email
                delivery provider.
              </li>
              <li>
                <b>Datadog</b> &mdash; provides application performance
                monitoring and may process technical data such as IP addresses
                and request metadata.
              </li>
              <li>
                <b>Sentry</b> &mdash; provides error and crash reporting and may
                process technical data such as IP addresses, device information
                and error details.
              </li>
              <li>
                <b>Atlassian (Jira Service Management)</b> &mdash; handles
                support requests submitted through our contact form, including
                your email address and any correspondence.
              </li>
              <li>
                <b>OpenAI</b> &mdash; when you use AI features, the prompts you
                provide are sent to OpenAI to generate suggestions.
              </li>
              <li>
                <b>Freesound and Voicy</b> &mdash; when you search for or import
                sounds from these third party libraries, your search terms are
                sent to them.
              </li>
            </ul>
            <b>Content you upload</b>
            <br />
            <br />
            Content can be uploaded by you or imported from third party
            libraries such as Freesound and Voicy. We do not check the content
            that you upload or import on our Platform for its legality or for
            whether it contains protected third party materials, we make no
            assurances as to whether it may lawfully be used by you, and under
            no circumstances are we advising you that your content falls under
            such permitted exceptions. You acknowledge and agree that it is your
            responsibility to satisfy yourself (by obtaining appropriate
            professional advice, the appropriate permissions or otherwise) that
            you can use third party materials in your content under the laws
            and/or legal principles applicable to your jurisdiction.
            <br />
            <br />
            Cookies are used on this site for analytics, user authentication,
            and session tracking.
            <br />
            <br />
            Your data is accessible to website administrators.
            <br />
            <br />
            To request to have your account data deleted please reach out via
            the contact form.
            <br />
            <br />
          </Typography>
        </Paper>
      </FullPageContentContainer>

      <Footer />
    </PageContainer>
  )
}
